import axios from "axios";

import { CLEAR_DATA, STATUSES } from "actions/ActionTypes";
import { formatHeaders, handleErrors, triggerError } from "utils/Api";
import { notifSuccess } from "actions/FlashMessageActions";
import rootURL from "utils/RootURL";

const sendFetchRequest = (type, status, item, params) => ({
  type,
  item,
  status,
  params,
});

export const fetchApi = ({
  endpoint,
  type,
  item,
  data,
  token,
  headers,
  message,
  error,
}) => {
  item = item || endpoint.split("/").pop();

  return (dispatch) => {
    dispatch(
      sendFetchRequest(type, STATUSES.STARTED, item, { ...data, endpoint }),
    );
    return axios({
      url: rootURL(endpoint),
      method: "GET",
      headers: formatHeaders(token, headers),
      params: data,
    })
      .then(handleErrors)
      .then((json) => {
        if (!json.errorType) {
          dispatch(sendFetchRequest(type, STATUSES.SUCCESSFUL, item, json));
          if (message) {
            dispatch(notifSuccess(message));
          }
        } else {
          // New Error System
          const e = {
            message: json.errorType,
            details: json.errorDetails,
          };
          dispatch(
            sendFetchRequest(type, STATUSES.FAILED, item, {
              ...data,
              endpoint,
            }),
          );
          triggerError(dispatch, e, error);
        }
      })
      .catch((e) => {
        dispatch(
          sendFetchRequest(type, STATUSES.FAILED, item, { ...data, endpoint }),
        );
        triggerError(dispatch, e, error);
      });
  };
};

export const clearData = (item) => ({
  type: CLEAR_DATA,
  status: STATUSES.SUCCESSFUL,
  item,
});
